import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ChecklistPersiapanAnestesiSvc from "@/services/ChecklistPersiapanAnestesi";

@Module({ store, dynamic: true, namespaced: true, name: "checklist-persiapan-anestesi" })
class ChecklistPersiapanAnestesiModule extends VuexModule {
  dataList: any[] = [];
  data: any = null;
  loading = false;

  @Mutation SET_DATALIST(val: any[]) {
    this.dataList = val;
  }

  @Mutation SET_DATA(val: any) {
    this.data = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await ChecklistPersiapanAnestesiSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_DATALIST(data || []);
    } catch {
      this.SET_DATALIST([]);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await ChecklistPersiapanAnestesiSvc.find(id);
      const { data } = dt.data;
      this.SET_DATA(data || null);
    } catch {
      // ignore
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_DATALIST([]);
    this.SET_DATA(null);
  }
}

export const storeChecklistAnestesi = getModule(ChecklistPersiapanAnestesiModule);
